import { IconWrapper } from '../runtime';
export default IconWrapper('finalized', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.4 8L7.15 9.75L10.6501 6.24973M13.25 5.12102C13.25 4.72319 13.092 4.34166 12.8107 4.06035L10.9393 2.18903C10.658 1.90773 10.2765 1.74969 9.87868 1.74969H4.25C3.42157 1.74969 2.75 2.42127 2.75 3.24969V12.7497C2.75 13.5781 3.42157 14.2497 4.25 14.2497H11.75C12.5784 14.2497 13.25 13.5781 13.25 12.7497V5.12102Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});